import { useCallback, useRef } from 'react';
import { DotLottieReact, setWasmUrl } from '@lottiefiles/dotlottie-react';

// Metro emits web asset requires as URL strings, so the .lottie bundle is
// served from the exported /assets dir. The renderer's WASM binary is
// pointed at a bundled copy (wasm is in metro.config.js assetExts) instead
// of relying on the package's jsdelivr/unpkg CDN fallback.
const CONFETTI_LOTTIE_URL = require('@/assets/confetti-burst.lottie');
setWasmUrl(require('@lottiefiles/dotlottie-web/dist/dotlottie-player.wasm'));

/**
 * Local confetti burst played once — web twin of
 * CelebrationConfetti.native.jsx (lottie-react-native maps to lottie-web,
 * which only understands JSON, not .lottie bundles). `onFailure` should
 * flip the parent's failure state so a broken asset unmounts instead of
 * sitting blank behind the celebration panel.
 *
 * @param {object} props
 * @param {object} props.style
 * @param {Function} props.onFailure
 */
const CelebrationConfetti = ({ style, onFailure }) => {
    const onFailureRef = useRef(onFailure);
    onFailureRef.current = onFailure;

    const refCallback = useCallback((dotLottie) => {
        dotLottie?.addEventListener('loadError', () => onFailureRef.current?.());
    }, []);

    return (
        <DotLottieReact
            src={CONFETTI_LOTTIE_URL}
            autoplay
            loop={false}
            style={style}
            dotLottieRefCallback={refCallback}
        />
    );
};

export default CelebrationConfetti;
